<template>
  <div>
    <FilterMenuVue @applyFilter="applyFilter">
      <v-container fluid style="width: 400px" class="py-0 px-2">
        <v-row align="center" v-if="!traegerView">
          <v-col>
            <v-select :items="roles" :item-title="(item) => $t('constants.' + item.name)" item-value="key"
              variant="outlined" :label="$t('basics.role')" return-object clearable hide-details
              v-model="selectedRole"></v-select>
          </v-col>
        </v-row>


        <v-row class="hoverable" align="center" @click="inactive = !inactive">
          <v-col>
            <v-icon size="large" class="icon-transparency" :color="inactive ? 'primary' : ''">
              mdi-cancel
            </v-icon>
            <span class="ml-2">{{ $t("constants.accountInactive") }}</span>
          </v-col>
        </v-row>
        <v-row class="hoverable" align="center" @click="notRegistered = !notRegistered">
          <v-col>
            <v-icon size="large" class="icon-transparency" :color="notRegistered ? 'primary' : ''">
              mdi-account-off
            </v-icon>
            <span class="ml-2">{{ $t("basics.notRegistered") }}</span>
          </v-col>
        </v-row>
        <v-row class="hoverable" align="center" @click="activePatient = !activePatient">
          <v-col>
            <v-icon size="large" class="icon-transparency" :color="activePatient ? 'primary' : ''">
              mdi-shield-account
            </v-icon>
            <span class="ml-2">{{ $t("basics.activePatient") }}</span>
          </v-col>
        </v-row>
      </v-container>
    </FilterMenuVue>
  </div>
</template>

<script>
import FilterMenuVue from "../main/FilterMenu.vue";

export default {
  name: "userListFilter",

  data() {
    return {
      notRegistered: false,
      roles: [],
      selectedRole: undefined,
      inactive: false,
      activePatient: false,
    };
  },

  components: {
    FilterMenuVue,
  },

  methods: {
    applyFilter() {
      this.$emit("filter", this.getParamString());
    },
    getReadableDate(date) {
      if (date) return this.$moment(date).format("DD.MM.YYYY");
      else return undefined;
    },
    getParamString() {
      // TODO: Edit filter options
      let query = "";
      let types = [];

      if (this.showDeprecated) {
        query += "&show_deprecated=1";
      }
      if (this.notRegistered) {
        query += "&notRegistered=1";
      }

      if (this.selectedRole) {
        query += "&role=" + this.selectedRole.key;
      }

      if (this.inactive) {
        query += "&deleted=1";
      }

      if (this.activePatient) {
        query += "&active=1"
      }

      return query;
    },

    fetchRoles() {
      this.axios
        .get(this.axios.defaults.baseURL + "user/roles/?show_all=1")
        .then((resp) => {
          this.roles = resp.data;
        })
        .catch((e) => {
          console.log(e);
          window.dispatchEvent(new CustomEvent("showErrorDisplay", { detail: e }));
        });
    },
  },
  mounted() {
    this.fetchRoles();
  },
};
</script>
